// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__XzSDV","container_video":"styles_container_video__hvKNj","video":"styles_video__yHrwF","container_content":"styles_container_content__bvm4Y"};